export const GET_TABLES= 'GET_TABLES'
export const GET_TABLES_SUCCESS= 'GET_TABLES_SUCCESS'
export const GET_TABLES_ERROR='GET_TABLES_ERROR'


export const GetTables= (data) => ({
    type: GET_TABLES,
    payload: data
});
